export default "__VITE_PUBLIC_ASSET__b39ebabf__"